import { render, staticRenderFns } from "./ShortNovel.vue?vue&type=template&id=779ca0df"
import script from "./ShortNovel.vue?vue&type=script&lang=js"
export * from "./ShortNovel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports